export enum Availability {
  outOfStock = 'out-of-stock',
  inStock = 'in-stock',
  lowStock = 'low-stock',
  veryLowStock = 'very-low-stock',
}

export enum FabricDisabledReason {
  launchDateAfterOrderDate = 'LaunchDateAfterOrderDate',
  carryOverRestricted = 'CarryOverRestricted',
}
